import { Module } from "vuex";
import { getters } from "./getters";
import { MapState } from "./types";
import { RootState } from "../types";
import { actions } from "./actions";
import { mutations } from "./mutations";
import { getDefaultState } from "./state";

export const state: MapState = getDefaultState();

const namespaced: boolean = true;

export const map: Module<MapState, RootState> = {
	namespaced,
	state,
	getters,
	actions,
	mutations,
};
